// @flow
import * as React from 'react';
import DialogContentText from '@mui/material/DialogContentText';
import { FormikProvider } from "formik";
import { useTranslation } from "react-i18next";
import Box from "@mui/material/Box";
import { dialogueContextTextDefaults } from "../../../helpers/theme/defaultProps";
import useExhibitionAction from "../../../hooks/exhibitions/useExhibitionAction";
import { EmailValid, useValidateEmail } from "../../../hooks/useValidateEmail";
import ActionStatus from "../alerts/actionStatus/actionStatus";
import useExhibitionData from "../../../hooks/exhibitions/useExhibitionData";
import { EXHIBITOR_PROFILE } from "../../../locales/components/namespaces";
import ConfirmDialog from "../dialogs/confirmDialog/confirmDialog";
import FormFields from "./partials/formFields";
import useAddVisitorForm from "./hooks/useAddVisitorForm";

type Props = {
	limitedView?: boolean,
	exhibitionId: string,
	open: boolean,
	onClose: Function,
}

export default function AddVisitorDialog(props: Props) {
	const { open, onClose, exhibitionId, exhibitorId, limitedView, exhibition, loading } = props
	const { t } = useTranslation(EXHIBITOR_PROFILE)
	const { actionOnVisitorStatus } = useExhibitionData()
	const { createVisitor, clearActionOnVisitorStatus } = useExhibitionAction()
	
	const {
		formik, emailIsValid, validateEmail, setEmailIsValid
	} = useAddVisitorForm({ exhibition, limitedView, exhibitionId, exhibitorId, createVisitor })
	
	const closeDialogue = () => {
		formik.resetForm();
		onClose();
		setEmailIsValid(EmailValid.Idle)
	}
	
	return (
		<ConfirmDialog
			maxWidth={"sm"}
			loading={loading}
			open={open}
			handleDialog={closeDialogue}
			title={t("Add a visitor")}
			otherDialogProps={{ keepMounted: true }}
			yesBtnText={t('Import')}
			onNo={closeDialogue}
			onYes={formik.handleSubmit}
			hasBtnIcons={false}
		>
			<FormikProvider value={formik}>
				<Box component="form" onSubmit={formik.handleSubmit} noValidate>
					<ActionStatus
						status={actionOnVisitorStatus}
						onClose={clearActionOnVisitorStatus}
					/>
					<DialogContentText
						{...dialogueContextTextDefaults}
					>
						{t('Type contact information of the person you want to add as a visitor for this event.')}
					</DialogContentText>
					<FormFields
						formik={formik}
						limitedView={limitedView}
						exhibitionId={exhibitionId}
						exhibition={exhibition}
						validateEmail={validateEmail}
						emailIsValid={emailIsValid}
					/>
				</Box>
			</FormikProvider>
		</ConfirmDialog>
	)
}
